/* eslint-disable no-console */

import {
  register
} from 'register-service-worker'

function broadcastEvent (key, data) {
  /* global CustomEvent */
  document.dispatchEvent(new CustomEvent(key, { detail: data }))
}

const isProduction = process.env.NODE_ENV === 'production' && process.env.VUE_APP_ENVIRONMENT === 'production'

if (isProduction) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('App is being served from cache by a service worker')
    },
    registered (registration) {
      broadcastEvent('service-worker-registration', { registration })
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      broadcastEvent('app-update-pending', { registration })
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
